module.exports = __webpack_public_path__ + "media/images/flags/64/Myanmar-4c0540a681238790d1f7e7303879c4c3.png";